import { render, staticRenderFns } from "./CollapsedPaystubReport.vue?vue&type=template&id=0d8c05ba&"
import script from "./CollapsedPaystubReport.vue?vue&type=script&lang=ts&"
export * from "./CollapsedPaystubReport.vue?vue&type=script&lang=ts&"
import style0 from "./CollapsedPaystubReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports